import { UserManagementAction, UserManagementActions } from '../actions/userManagement.action';
import { UserManagementState } from '../../store/state';

const initialState: UserManagementState = {
  userDetails: null,
  users: null,
  updateUser: null,
};

const userManagementReducer = (state: UserManagementState = initialState, action: UserManagementAction): UserManagementState => {
  switch (action.type) {
    case UserManagementActions.LoadUserInfo:
      return {
        ...state,
        userDetails: {
          ...state?.userDetails,
          isLoading: true,
          data: null,
          error: null,
        }
      };
    case UserManagementActions.LoadUserInfoSucceed:
      return {
        ...state,
        userDetails: {
          ...state?.userDetails,
          isLoading: false,
          error: null,
          data: action.payload,
        }
      };
    case UserManagementActions.LoadUserInfoFailed:
      return {
        ...state,
        userDetails: {
          ...state?.userDetails,
          isLoading: false,
          data: null,
          error: action.payload,
        }
      };
    case UserManagementActions.LoadUsers:
      return {
        ...state,
        users: {
          ...state?.users,
          isLoading: true,
          data: null,
          error: null,
        }
      };
    case UserManagementActions.LoadUsersSucceed:
      return {
        ...state,
        users: {
          ...state?.users,
          isLoading: false,
          error: null,
          data: action.payload,
        }
      };
    case UserManagementActions.LoadUsersFailed:
      return {
        ...state,
        users: {
          ...state?.users,
          isLoading: false,
          data: null,
          error: action.payload,
        }
      };
    case UserManagementActions.RemoveUsers:
      return {
        ...state,
        users: {
          ...state?.users,
          isRemoving: true,
        }
      };
    case UserManagementActions.RemoveUsersSucceed:
      return {
        ...state,
        users: {
          ...state?.users,
          isRemoving: false,
        }
      };
    case UserManagementActions.RemoveUsersFailed:
      return {
        ...state,
        users: {
          ...state?.users,
          isRemoving: false,
          error: action.payload
        }
      };
    case UserManagementActions.LoadUserForUpdate:
      return {
        ...state,
        updateUser: {
          user: null,
          loading: true,
          saving: false,
          saved: false,
          error: null
        }
      };
    case UserManagementActions.LoadUserForUpdateSuccess:
      return {
        ...state,
        updateUser: {
          user: action.payload,
          loading: false,
          saving: false,
          saved: false,
          error: null
        }
      };
    case UserManagementActions.UpdateUser:
    case UserManagementActions.CreateUser:
    case UserManagementActions.ResetUserPassword:
      return {
        ...state,
        updateUser: {
          user: null,
          loading: false,
          saving: true,
          saved: false,
          error: null
        }
      };
    case UserManagementActions.UpdateUserSuccess:
    case UserManagementActions.CreateUserSuccess:
      return {
        ...state,
        users: {
          ...state.users,
          data: [
            ...(state.users?.data?.filter(user => user.id !== action.payload.id) || []),
            action.payload,
          ],
        },
        updateUser: {
          user: action.payload,
          loading: false,
          saving: false,
          saved: true,
          error: null
        }
      };
    case UserManagementActions.ResetUserPasswordSuccess:
      return {
        ...state,
        updateUser: {
          loading: false,
          saving: false,
          saved: true,
          error: null
        }
      };
    case UserManagementActions.LoadUserForUpdateFailed:
    case UserManagementActions.CreateUserFailed:
    case UserManagementActions.ResetUserPasswordFailed:
      return {
        ...state,
        updateUser: {
          user: null,
          loading: false,
          saving: false,
          saved: false,
          error: action.payload
        }
      };
    case UserManagementActions.UpdateUserFailed:
      return {
        ...state,
        updateUser: {
          user: state.updateUser.user,
          loading: false,
          saving: false,
          saved: false,
          error: action.payload
        }
      };
    case UserManagementActions.ResetUpdateUserState:
      return {
        ...state,
        updateUser: {
          user: null,
          loading: false,
          saving: false,
          saved: false,
          error: null,
        }
      };
    default:
      return state;
  }
};

export default userManagementReducer;
